

import Component from './component';
import createComponentFactory from '../createComponent';
import { TWITTER_SHARE_URL } from '../constant/shareEndpoint';


class TwitterShare extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    this._originalHref = '';

  }

  _bindEvents() {

  }

  _unbindEvents() {

  }

  didRegisterComponent() {
    this._originalHref = this.element.getAttribute('href');

    // share urlを組み立てる
    const url = TWITTER_SHARE_URL + `?url=${encodeURIComponent(location.href)}&text=${encodeURIComponent(document.title)}`;
    this.element.setAttribute('href', url);

  }

  didUnregisterComponent() {
    this.element.setAttribute('href', this._originalHref);
  }


}

export default createComponentFactory(TwitterShare);




// WEBPACK FOOTER //
// ./src/js/app/component/twitterShare.js